import { render } from "./OccupationCard.vue?vue&type=template&id=37a12c40"
import script from "./OccupationCard.vue?vue&type=script&lang=js"
export * from "./OccupationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__